(function () {
  'use strict';
  var all = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  all('[data-fest]').forEach(function (root) {
    var row = root.querySelector('[data-fest-row]');
    var bubble = root.querySelector('[data-fest-bubble]');
    var tabs = all('[data-fest-tab]', root);
    var panels = all('[data-fest-panel]', root);
    if (!row || !bubble || !tabs.length) return;
    var current = 0;
    for (var i = 0; i < tabs.length; i++) if (tabs[i].getAttribute('aria-selected') === 'true') current = i;

    var placeCaret = function () {
      var tab = tabs[current], media = tab.querySelector('.fest-cat__media') || tab;
      var a = media.getBoundingClientRect(), b = bubble.getBoundingClientRect();
      var x = a.left + a.width / 2 - b.left;
      x = Math.max(28, Math.min(b.width - 28, x));
      bubble.style.setProperty('--caret-x', Math.round(x) + 'px');
    };

    var revealTab = function (tab) {
      if (row.scrollWidth <= row.clientWidth + 2) return;
      var left = tab.offsetLeft - (row.clientWidth - tab.offsetWidth) / 2;
      row.scrollLeft = Math.max(0, left);
    };

    var select = function (i, focus) {
      if (i === current) { if (focus) tabs[i].focus(); return; }
      tabs[current].setAttribute('aria-selected', 'false');
      tabs[current].setAttribute('tabindex', '-1');
      panels[current].hidden = true;
      current = i;
      tabs[i].setAttribute('aria-selected', 'true');
      tabs[i].setAttribute('tabindex', '0');
      panels[i].hidden = false;
      if (window.CS && window.CS.showSkeleton) window.CS.showSkeleton(panels[i]);
      if (focus) tabs[i].focus();
      revealTab(tabs[i]);
      placeCaret();
      var track = panels[i].querySelector('[data-rail-track]');
      if (track) track.scrollLeft = 0;
      window.dispatchEvent(new Event('resize'));
    };

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i, false); });
    });
    row.addEventListener('keydown', function (e) {
      var k = e.key, n = tabs.length, next = null;
      if (k === 'ArrowRight' || k === 'ArrowDown') next = (current + 1) % n;
      else if (k === 'ArrowLeft' || k === 'ArrowUp') next = (current - 1 + n) % n;
      else if (k === 'Home') next = 0;
      else if (k === 'End') next = n - 1;
      if (next === null) return;
      e.preventDefault();
      select(next, true);
    });

    var queued = false;
    var later = function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () { queued = false; placeCaret(); });
    };
    row.addEventListener('scroll', later, { passive: true });
    window.addEventListener('resize', later);
    placeCaret();
    window.requestAnimationFrame(placeCaret);
    var img = tabs[current].querySelector('img');
    if (img && !img.complete) img.addEventListener('load', placeCaret);
  });

  all('[data-fest-more]').forEach(function (box) {
    var body = box.querySelector('[data-fest-more-body]');
    var btn = box.querySelector('[data-fest-more-toggle]');
    if (!body || !btn) return;
    if (body.scrollHeight <= body.clientHeight + 4) { box.classList.add('is-open'); btn.hidden = true; return; }
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    btn.addEventListener('click', function () {
      var open = !box.classList.contains('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Read less' : 'Read more';
      if (still) { box.classList.toggle('is-open', open); return; }
      var from = body.getBoundingClientRect().height;
      box.classList.toggle('is-open', open);
      var to = open ? body.scrollHeight : body.getBoundingClientRect().height;
      body.style.maxHeight = from + 'px';
      body.getBoundingClientRect();
      body.style.maxHeight = to + 'px';
      var done = function (ev) {
        if (ev && ev.propertyName !== 'max-height') return;
        body.style.maxHeight = '';
        body.removeEventListener('transitionend', done);
      };
      body.addEventListener('transitionend', done);
      if (!open) box.scrollIntoView({ block: 'nearest' });
    });
  });
})();
